import { api } from "@/api/client";

export type ApprovalQueueStatus = "pending" | "rejected" | "approved";
export type ApprovalQueueSort = "vendor" | "invoice" | "amount" | "bill_date" | "approver" | "created" | "entered_by";

// One vendor bill on the Triage approval tabs: live from NetSuite, plus what
// the app knows about it (emailed, sent back, decided here).
export interface ApprovalQueueRow {
  netsuite_bill_id: number;
  tranid: string | null;
  trandate: string | null;
  duedate: string | null;
  amount: number | null;
  memo: string | null;
  vendor_name: string | null;
  approver_name: string | null;
  submitter_name: string | null;
  created: string | null;
  netsuite_url: string | null;
  emailed_at: string | null;
  reroute: { requested_at: string; by_name: string | null; to_name: string | null; comment: string | null } | null;
  decided_by_name: string | null;
  decided_at: string | null;
  comment: string | null;
}

export interface ApprovalQueueParams {
  status: ApprovalQueueStatus;
  page: number;
  per_page: number;
  q?: string;
  vendor_id?: string;
  date_from?: string;
  date_to?: string;
  sort?: ApprovalQueueSort;
  dir?: "asc" | "desc";
}

export async function fetchApprovalQueue(params: ApprovalQueueParams): Promise<{ items: ApprovalQueueRow[]; total: number }> {
  const { data } = await api.get<{ items: ApprovalQueueRow[]; total: number }>("/bill_approval_queues", { params });
  return data;
}

export async function fetchApprovalQueueCounts(): Promise<{ pending: number; rejected: number }> {
  const { data } = await api.get<{ pending: number; rejected: number }>("/bill_approval_queues/counts");
  return data;
}
